module.exports = __webpack_public_path__ + "static/media/Plus.80a4efc6.svg";